import React from 'react';
import { connect } from 'react-redux';


const TechnicianTimeSlotsCellcomHeader = (props) =>  {
    const bezeqTimeSlot = props.selectedTimeSlots.find(x => x.type == "BEZEQ");

    return (
        <div className="technician-time-slots-cellcom-header">
            <div className='bezek-time-slot'>
                <p>מועד הגעת טכנאי תשתית שבחרת</p>
                {bezeqTimeSlot.displayDate}
            </div>
            <h2>מועד הגעת טכנאי {window.Config.brand_Name_HE}</h2>
            <p>מועד טכנאי בזק שבחרת קרוב מידי למועד טכנאי {window.Config.brand_Name_HE} שמזומן לך כבר</p>          
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        selectedTimeSlots: state.technicianUpdatesBlock.selectedTimeSlots,
    };
  };
  
  const mapDispatchToProps = {
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(TechnicianTimeSlotsCellcomHeader);